<template>
    <div class="editor_panel" :class="isNavigationVisible ? '' : 'navigationHidden'" v-if="isTabPanelVisible" :style="colors">
        <div class="editor_panel-nav" v-if="isNavigationVisible">
            <div
                v-for="(icon, index) in elementsNavIcons"
                :key="index"
                :class="[getCurrentTab === icon.boundedTab ? 'activePanel' : '']"
                class="tooltipElement tooltipRight"
                @click="changeTab(icon.boundedTab)"
            >
                <div v-if="tabIsHidden(icon.boundedTab)" class="editor_panel-nav-item">
                    <inline-svg
                        :alt="icon.name"
                        :src="icon.svg"
                        :fill="svgFill(icon.boundedTab)"
                    />
                    <span>{{ icon.title }}</span>
                </div>
                <Tooltip :tooltipText="icon.title" />
            </div>
            <QrCodeTab v-if="getSessionDetails.mode === 'merchant'"/>
            <Lang />
            <div
                class="editor_panel-nav-item adminIcon"
                v-if="getSessionDetails.mode === 'merchant'"
            >
                <router-link :to="{ name: 'templates' }">
                    <inline-svg
                        alt="Back to formats"
                        :src="adminIcon"
                        fill="#737373"
                    />
                </router-link>
            </div>
        </div>
        <PanelTab
            :activeTab="getCurrentTab"
        ></PanelTab>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    import PanelTab from './PanelTab';
    import QrCodeTab from './TabContent/qrCodeTab.vue'
    import Tooltip from '@/components/Global/Tooltip.vue';
    import Lang from '@/components/Global/Language.vue';

    import add_image_icon from '@/assets/icons/panel_icons/upload.svg';
    import add_image_cell_icon from '@/assets/icons/panel_icons/image_cell.svg';
    import add_shape_icon from '@/assets/icons/panel_icons/shape.svg';
    import add_text_icon from '@/assets/icons/panel_icons/text.svg';
    import add_theme_icon from '@/assets/icons/panel_icons/theme.svg';
    import admin_icon from '@/assets/icons/panel_icons/home.svg';
    import placeholders_icon from '@/assets/icons/placeholders.svg'

    export default {
        data() {
            return {
                adminIcon: admin_icon,
                elementsNavIcons: [
                    { 
                        name: 'add_theme',
                        title: this.$i18n.t('editorTabItemProjects'),
                        svg: add_theme_icon,
                        boundedTab: 'themeTab'
                    },
                    { 
                        name: 'add_image',
                        title: this.$i18n.t('editorTabItemUploads'),
                        svg: add_image_icon,
                        boundedTab: 'imageTab'
                    },
                    { 
                        name: 'add_image_cell',
                        title: this.$i18n.t('editorTabItemFrames'),
                        svg: add_image_cell_icon,
                        boundedTab: 'photoCellTab'
                    },
                    { 
                        name: 'add_text',
                        title: this.$i18n.t('editorTabItemText'),
                        svg: add_text_icon,
                        boundedTab: 'textTab'
                    },
                    { 
                        name: 'add_shape',
                        title: this.$i18n.t('editorTabItemShapes'),
                        svg: add_shape_icon,
                        boundedTab: 'shapeTab'
                    },
                    { 
                        name: 'fill_placeholders',
                        title: this.$i18n.t('editorTabItemForms'),
                        svg: placeholders_icon,
                        boundedTab: 'placeholderTab'
                    }
                ],
                visiblePanels: null
            }
        },
        methods: {
            svgFill(activeIcon) {
                return this.getCurrentTab === activeIcon ? `#${this.getSessionDetails.editorSetup.colors.primaryColor}` : '#737373';
            },
            changeTab(icon) {
                this.$store.dispatch('CHANGE_TAB', icon)
            },
            tabIsHidden(tabName) {
                if (this.getSessionDetails.mode === 'user') {
                    return this.getSessionDetails.editorSetup.hiddenTabs[tabName] === true ? false : true;
                } return true;
            },
            visiblePanelsFunc() {
                let visiblePanels = [];
                Object.keys(this.getSessionDetails.editorSetup.hiddenTabs).forEach(tab => {
                    if (this.getSessionDetails.editorSetup.hiddenTabs[tab] === false) {
                        visiblePanels.push(tab)
                    }
                });

                this.visiblePanels = visiblePanels;

                if (this.visiblePanels.length > 0) {
                    if (!this.visiblePanels.includes('themeTab')) {
                        this.$store.dispatch('CHANGE_TAB', this.visiblePanels[0]);
                    }
                }
            }
        },
        computed: {
            ...mapGetters([
                'getCurrentTab',
                'getSessionDetails'
            ]),
            isTabPanelVisible() {
                if (this.getSessionDetails.mode === 'user') {
                    let visiblePanels = [];
                    Object.keys(this.getSessionDetails.editorSetup.hiddenTabs).forEach(tab => {
                        if (this.getSessionDetails.editorSetup.hiddenTabs[tab] === false) {
                            visiblePanels.push(tab)
                        }
                    });

                    if (visiblePanels.length > 0) {
                        return true;
                    } return false;
                } return true;
            },
            colors() {
                return {
                    '--primary-color': `#${this.getSessionDetails.editorSetup.colors.primaryColor}`
                }
            },
            isNavigationVisible() {
                if (this.getSessionDetails.mode === 'user') {
                    if (this.visiblePanels.length > 1) {
                        return true;
                    } return false;
                } return true;
            }
        },
        created() {
            if (this.getSessionDetails.mode === 'user') {
                this.visiblePanelsFunc();
            }            
        },
        components: {
            PanelTab,
            QrCodeTab,
            Tooltip,
            Lang
        }
    }
</script>

<style lang="scss" scoped>
    .editor_panel {
        width: 25%;
        display: grid;
        grid-template-columns: 50px auto;

        &.navigationHidden {
            grid-template-columns: auto;
        }

        &-nav-item {
            font-size: 12px;
            font-weight: 600;
            line-height: 20px;
            margin: 5px 0;
            cursor: pointer;

            span {
                display: block;
            }
        }
    }
    @media (max-width: 1500px) {
        .editor_panel {
            width: 300px;
        }
    }
    @media (max-width: 1200px) {
        .editor_panel {
            width: 260px;
        }
    }
    
    .activePanel,
    .editor_panel-nav-item:hover {
        color: var(--primary-color);
    }
    .activePanel svg,
    .editor_panel-nav-item:hover svg {
        fill: var(--primary-color);
    }
    .activePanel svg {
        fill: #310048;
    }
    // .adminIcon {
    //     align-self: end;
    // }
</style>